import Vue from 'vue'
import Toast from 'vue2-toast'
import VueClipboard from 'vue-clipboard2'
// import Pagination from 'laravel-vue-pagination';
import { Datetime } from 'vue-datetime'
// import vSelect from 'vue-select'
import App from './App.vue'
import router from './router'
import 'vue2-toast/lib/toast.css'
import 'vue-datetime/dist/vue-datetime.css'
import 'vue-select/dist/vue-select.css'
import 'bootstrap/dist/css/bootstrap.css';

Vue.config.productionTip = false
Vue.prototype.globalData = {
  musicList: [],
}

Vue.use(Toast, {
  type: 'center',
  duration: 1000,
  wordWrap: true,
  width: '180px',
})

Vue.use(VueClipboard)
Vue.use(Datetime)
Vue.component('datetime', Datetime)
// Vue.component('pagination', Pagination);
Vue.component('pagination', require('laravel-vue-pagination'));
// Vue.component('v-select', vSelect)

export default new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
